export default __webpack_public_path__ + "static/media/do_circle.0f0d0558.png";